
import * as yup from "yup";

export const changePasswardSchema = yup.object().shape({

    oldPassword: yup.string().required('Old Password is required'),
    newPassword: yup.string().required('Password is required'),
    passwordConfirmation: yup.string()
        .oneOf([yup.ref('newPassword'), null], 'Passwords must match')
}).required();